let lastShownFor: { locationId: string | undefined; saleType: number | undefined } | null = null;

export const shouldShowPresaleModal = (
  locationId: string | undefined,
  saleType: number | undefined,
): boolean => {
  if (lastShownFor && lastShownFor.locationId === locationId && lastShownFor.saleType === saleType) {
    return false;
  }

  lastShownFor = { locationId, saleType };
  return true;
};
